/**
 * @generated SignedSource<<14ca1a19ff09c6335bde96e1e188c0cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PickAssetInput = {
  assetTag: any;
  clientMutationId?: string | null | undefined;
  reservationId: string;
};
export type OpsReservationPagePickMutation$variables = {
  input: PickAssetInput;
};
export type OpsReservationPagePickMutation$data = {
  readonly pickAsset: {
    readonly reservation: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly assetTag: any | null | undefined;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsReservationPagePickMutation = {
  response: OpsReservationPagePickMutation$data;
  variables: OpsReservationPagePickMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PickAssetPayload",
    "kind": "LinkedField",
    "name": "pickAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationPagePickMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationPagePickMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ed4f57f293a1c8167dbdbde4d23667c3",
    "id": null,
    "metadata": {},
    "name": "OpsReservationPagePickMutation",
    "operationKind": "mutation",
    "text": "mutation OpsReservationPagePickMutation(\n  $input: PickAssetInput!\n) {\n  pickAsset(input: $input) {\n    reservation {\n      id\n    }\n    userErrors {\n      message\n      assetTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9d3512ed70c918d17bf15c9591d9b88";

export default node;
